var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSecurity(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 12.25h7V7h-7v5.25zm7-6.125h-7A.875.875 0 002.625 7v5.25c0 .483.392.875.875.875h7a.875.875 0 00.875-.875V7a.875.875 0 00-.875-.875zM4.842 3.5c0-.965.785-1.75 1.75-1.75h.816c.965 0 1.75.785 1.75 1.75v1.75h.875V3.5A2.633 2.633 0 007.408.875h-.816A2.633 2.633 0 003.967 3.5v1.75h.875V3.5z",
    fill: "#CE2B18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.563 9.504v1.434h.875V9.504a.87.87 0 00.437-.754.875.875 0 00-1.75 0 .87.87 0 00.438.754z",
    fill: "#CE2B18"
  })));
}

export default SvgIconSecurity;